import dom from '../../../wrapper/DomWrapper';
import SingleProduct from '../../Ecommerce/SingleProduct';
import Ecommerce from '../../../ecommerce';

import { getLabelClass } from './utils';
import { getImageSize } from '../../Ecommerce/utils';

const preInit = async () => ({
  provider: Ecommerce.provider,
});

/**
 * this - LayoutController bound to the function
 * @returns product
 */
function preRender(product, index, elContainer) {
  const {
    layoutSettings: {
      // eslint-disable-next-line camelcase
      grid: { items_per_row } = {},
      layoutType,
    },
  } = this.settings;
  let imageSize = 'imageOriginalUrl';

  // eslint-disable-next-line camelcase
  if (elContainer && layoutType === 'grid' && items_per_row) {
    // eslint-disable-next-line camelcase
    imageSize = getImageSize(dom.getElementWidth(elContainer) / items_per_row);
  }

  return {
    product,
    withLabel: getLabelClass(product),
    withGallery: product.images.length > 1,
    imageSize,
  };
}

function postRender(element, product, index) {
  (new SingleProduct(dom.getElement('div.product', element), product)).init(index);
  return element;
}

// eslint-disable-next-line no-unused-vars
const didMount = (container) => {};

export default {
  preInit,
  preRender,
  postRender,
  didMount,
};
